var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-layout"},[_vm._v(" Ops... 404 not found "),_c('router-link',{attrs:{"to":"home"}},[_vm._v("点击：返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }